module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Romanshorn-545b691c21a116d76c2e438ccb7a2fa5.svg";